define('home/views/HomepageFollowingModuleView',[
    'backbone-marionette',

    'home/models/Session',
    'home/views/FollowingCardView',
    'home/templates/homepageFollowingModule',
], function (
    Marionette,

    Session,
    FollowingCardView,
    homepageFollowingModuleTemplate
) {
    'use strict';

    var HomepageFollowingModuleView = Marionette.CompositeView.extend({
        template: homepageFollowingModuleTemplate,
        templateHelpers: function () {
            return {
                sessionUsername: Session.fromCookie().username,
            };
        },

        itemViewContainer: '[data-role=forums]',
        itemView: FollowingCardView,

        addItemView: function (item, ItemView, index) {
            if (index > 4)
                return;

            return Marionette.CompositeView.prototype.addItemView.call(this, item, ItemView, index);
        },

        initialize: function () {
            this.session = Session.get();
        },
    });

    return HomepageFollowingModuleView;
});

